import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getShipmentsCount,
    getShipmentRatesCount,
    getAdjustmentsCount,
    getShipmentsWithRatesCount,
    getShipmentsWithNoRatesCount,
    getSurchargesCount,
    getNonZeroSurchargesCount,
    getIntegrationSummary,
} from '../../helpers';
import {
    integrationSummaryAnalyticsApiResponseSuccess,
    integrationSummaryAnalyticsApiResponseError,
} from './actions';
import { IntegrationSummaryAnalyticsActionTypes } from './constants';

export function* getShipmentsCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT, error));
    }
}

export function* getShipmentRatesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentRatesCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT, error));
    }
}

export function* getAdjustmentsCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getAdjustmentsCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT, error));
    }
}

export function* getShipmentsWithRatesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsWithRatesCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT, error));
    }
}

export function* getShipmentsWithNoRatesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsWithNoRatesCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT, error));
    }
}

export function* getSurchargesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getSurchargesCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT, error));
    }
}

export function* getNonZeroSurchargesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getNonZeroSurchargesCount, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT, error));
    }
}

export function* getIntegrationSummarySaga({ payload: { query } }) {
    try {
        const response = yield call(getIntegrationSummary, query);
        yield put(integrationSummaryAnalyticsApiResponseSuccess(IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY, response.data));
    } catch (error) {
        yield put(integrationSummaryAnalyticsApiResponseError(IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY, error));
    }
}

export function* watchGetShipmentsCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_COUNT, getShipmentsCountSaga);
}

export function* watchGetShipmentRatesCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENT_RATES_COUNT, getShipmentRatesCountSaga);
}

export function* watchGetAdjustmentsCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_ADJUSTMENTS_COUNT, getAdjustmentsCountSaga);
}

export function* watchGetShipmentsWithRatesCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_RATES_COUNT, getShipmentsWithRatesCountSaga);
}

export function* watchGetShipmentsWithNoRatesCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_SHIPMENTS_WITH_NO_RATES_COUNT, getShipmentsWithNoRatesCountSaga);
}

export function* watchGetSurchargesCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_SURCHARGES_COUNT, getSurchargesCountSaga);
}

export function* watchGetNonZeroSurchargesCountSaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_NON_ZERO_SURCHARGES_COUNT, getNonZeroSurchargesCountSaga);
}

export function* watchGetIntegrationSummarySaga() {
    yield takeLatest(IntegrationSummaryAnalyticsActionTypes.GET_INTEGRATION_SUMMARY, getIntegrationSummarySaga);
}

function* integrationSummaryAnalyticsSaga() {
    yield all([
        fork(watchGetShipmentsCountSaga),
        fork(watchGetShipmentRatesCountSaga),
        fork(watchGetAdjustmentsCountSaga),
        fork(watchGetShipmentsWithRatesCountSaga),
        fork(watchGetShipmentsWithNoRatesCountSaga),
        fork(watchGetSurchargesCountSaga),
        fork(watchGetNonZeroSurchargesCountSaga),
        fork(watchGetIntegrationSummarySaga),
    ]);
}

export default integrationSummaryAnalyticsSaga;
